"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ERoleLabel = void 0;
const EnumObject_1 = require("./EnumObject");
const enumValues = {
    CLIENT: "CLIENT",
    SUPPORT: "SUPPORT",
    ORG_ADMIN: "ORG_ADMIN",
    UNIT_ADMIN: "UNIT_ADMIN",
    ACCOUNT_ADMIN: "ACCOUNT_ADMIN",
    LEGAL: "LEGAL",
    GRAPHIC: "GRAPHIC",
    LEAD: "LEAD",
    SALES: "SALES",
    MARKETING: "MARKETING",
    DEVEL: "DEVEL",
    PROGRAMMATIC: "PROGRAMMATIC",
    PUBLIC: "PUBLIC",
    EVAL: "EVAL",
    PORTAL: "PORTAL",
    APP: "APP",
    STORE: "STORE",
    READONLY: "READONLY",
    LEGACY: "LEGACY",
    CORE: "CORE",
    EXTERNAL: "EXTERNAL",
    MODULE_USER: "MODULE_USER",
    MODULE_PROJECTS: "MODULE_PROJECTS",
    MODULE_TASKS: "MODULE_TASKS",
    FULL_ACCESS: "FULL_ACCESS",
    OWNER: "OWNER",
};
class ERoleLabel extends EnumObject_1.EnumObject {
    constructor(value) {
        super(value);
    }
    static create(p) {
        return new ERoleLabel(p);
    }
}
exports.ERoleLabel = ERoleLabel;
ERoleLabel.V = enumValues;
//# sourceMappingURL=ERoleLabel.js.map